import { SalesCreditRoleDto } from "src/api-service";

// **************************************************************************
// SALES CREDIT ROLE STATE
// **************************************************************************
export interface SalesCreditRoleState {
    salesCreditRole: SalesCreditRoleDto | null;
    salesCreditRoles: SalesCreditRoleDto[];
    salesCreditRolesLoading: boolean;
}

export const initialSalesCreditRoleState: SalesCreditRoleState = {
    salesCreditRole: null,
    salesCreditRoles: [],
    salesCreditRolesLoading: false,
};
